import { Outlet } from 'react-router-dom'

import CollectionsBootstrap from 'modules/contracts/lib/EmployeesCollectionsBootstrap'

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

export default RootPage
